import React, { useContext, useState } from 'react'
import { generateBaggageKey, getDateAndTime } from 'AccountsUtils'
import { AccountsContext } from 'AccountsContext'

const BaggageInfo = ({ baggages }) => {
  const {
    selectedTrip
  } = useContext(AccountsContext)
  let baggageView = null
  const baggageFields = []
  for (const flight of selectedTrip.airInfo.flightDetails) {
    for (const segment of flight.segmentDetails) {
      baggageFields.push({
        from: segment.departureAirport,
        to: segment.arrivalAirport,
        key: generateBaggageKey(
          segment.departureAirport,
          segment.arrivalAirport,
          (new Date(getDateAndTime(segment.departureDate, '5.5', true)[0])).toUTCString(),
          getDateAndTime(segment.departureDate, '5.5')[1]
        )
      })
    }
  }

  const [activeIndex, setActiveIndex] = useState('')
  const [expanderFlag, updateExpanderFlag] = useState(false)
  const baggageKey = baggages[0].BI
  const toggleBaggageText = index => () => {
    if (!expanderFlag) {
      setActiveIndex(index)
    } else if (expanderFlag && index !== activeIndex) {
      setActiveIndex(index)
    } else {
      setActiveIndex(-1)
    }
    updateExpanderFlag(!expanderFlag)
  }
  const showBaggageInfo = (infoObj, index) => {
    let returnInfo = ''
    if (infoObj &&
      infoObj.bg &&
      infoObj.bg.ADT &&
      (infoObj.bg.ADT.cab || infoObj.bg.ADT.cib)) {
      returnInfo = (
        <React.Fragment>
          <div className="fs-12 amt-2 aml-5 ml5"> Cabin: {infoObj.bg.ADT.cab || '--'} | Check-in: {infoObj.bg.ADT.cib || '--'}</div>
        </React.Fragment>
      )
    } else if (infoObj &&
      infoObj.bg &&
      infoObj.bg.ADT &&
      infoObj.bg.ADT.free_text) {
      returnInfo = (
        <React.Fragment>
          <div className={index === activeIndex ? 'fs-12 amt-2 free-text-box expander' : 'fs-12 amt-2 free-text-box'}>
            {infoObj.bg.ADT.free_text}
            <span className="handle" onClick={toggleBaggageText(index)}>
              {index === activeIndex ? '...Read Less' : '...Read More'}
            </span>
          </div>
        </React.Fragment>
      )
    } else {
      returnInfo = (
        <React.Fragment>
          <h4 className="ta-l c-black-60 amt-10 lh-title amb-15 apl-15 apr-15 c-white">
            <div className="flex amb-5 fs-14">
              <div className="flex-1 fw-600 amr-10">Cleartrip Support:</div>
              <a className="phone_link" href={`tel:${selectedTrip.cleartripSupportNumber}`}>{selectedTrip.cleartripSupportNumber}</a>
            </div>
            <div>
              Baggage information not available - Please call cleartrip support to get the details.
            </div>
          </h4>
        </React.Fragment>
      )
    }
    return returnInfo
  }
  baggageView = (
    <React.Fragment>
      {
        baggageFields.map((baggage, index) => (
          <div className="flex flex-wrap">
            <div>{baggage.from} → {baggage.to} :</div>
            {showBaggageInfo(baggageKey[baggage.key], index)}
          </div>
        ))
      }
    </React.Fragment>
  )

  return (
    <React.Fragment>
      {baggageView}
    </React.Fragment>
  )
}

export default BaggageInfo
